define(["require", "exports", "./ServiceBase"], function (require, exports, ServiceBase_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CommonService = void 0;
    class CommonService extends ServiceBase_1.ServiceBase {
        constructor(httpProtocol, hostName, serviceName, proxyUrl) {
            super("Common", httpProtocol, hostName, serviceName, proxyUrl);
        }
        getEntityDataForDashboard(dashboardParams) {
            let p = {};
            p.dashboardParams = dashboardParams;
            return this.post("GetEntityDataForDashboard", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgas() {
            let p = {};
            return this.post("GetAuthorisedLgas", p, (json) => {
                return json;
            });
        }
        getAuthorisedLgasWithGeometry(returnPolyline, generalise) {
            let p = {};
            p.returnPolyline = returnPolyline;
            p.generalise = generalise;
            return this.post("GetAuthorisedLgasWithGeometry", p, (json) => {
                return json;
            });
        }
        getConfiguration() {
            let p = {};
            return this.post("GetConfiguration", p, (json) => {
                return json;
            });
        }
        getLgas() {
            let p = {};
            return this.post("GetLgas", p, (json) => {
                return json;
            });
        }
        getLotPlanQvasEvaluation(lotPlan) {
            let p = {};
            p.lotPlan = lotPlan;
            return this.post("GetLotPlanQvasEvaluation", p, (json) => {
                return json;
            });
        }
        getUser() {
            let p = {};
            return this.post("GetUser", p, (json) => {
                return json;
            });
        }
        keepAlive() {
            let p = {};
            return this.post("KeepAlive", p, (json) => {
                return json;
            });
        }
    }
    exports.CommonService = CommonService;
});
